import React, { useState } from "react";
import { BrowserRouter as Router, Link } from "react-router-dom";
import styles from "../../styles/Navbar.module.css";
import logo from "../../assets/logo_wide.png";

function Navbar() {
    const [menuOpen, setMenuOpen] = useState(false);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    const closeMenu = () => {
        setMenuOpen(false);
    };

    return (
        <div className={styles.navigation}>
            <nav>
                <Link to="/en" onClick={closeMenu}>
                    <img src={logo} alt="MyLogo" className={styles.logoImage} />
                </Link>

                {/* Hamburger Icon */}
                <div
                    className={`${styles.hamburger} ${menuOpen ? styles.open : ""}`}
                    onClick={toggleMenu}
                >
                    <span className={styles.bar}></span>
                </div>

                <ul className={`${styles.navLinks} ${menuOpen ? styles.showMenu : ""}`}>
                    <li className={styles.hasSubmenu}>
                        <Link to="/en/aboutus" onClick={closeMenu}>
                            About Us
                        </Link>
                        <ul className={styles.submenu}>
                            <li>
                                <Link to="/en/aboutus#company-overview" onClick={closeMenu}>
                                    Overview
                                </Link>
                            </li>
                            <li>
                                <Link to="/en/aboutus#ceo-greeting" onClick={closeMenu}>
                                    Message
                                </Link>
                            </li>
                            <li>
                                <Link to="/en/aboutus#member-intro" onClick={closeMenu}>
                                    Members
                                </Link>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <Link to="/en/work" onClick={closeMenu}>
                            Works
                        </Link>
                    </li>
                    <li>
                        <Link to="/en/recruit" onClick={closeMenu}>
                            Recruitment
                        </Link>
                    </li>
                    <li>
                        <Link to="/en/contact" onClick={closeMenu}>
                            Contact
                        </Link>
                    </li>
                    <li>
                        <Link to="/" onClick={closeMenu}>
                            Japanese
                        </Link>
                    </li>
                </ul>
            </nav>
        </div>
    );
}

export default Navbar;
